import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { buildCampaignViewRequest } from "./contentContract";

const API_URL = config.API_URL;
const retiredPaymentFields = new Set([
  "payment_required", "amount", "price", "total_cost", "currency",
  "oneoff_campaign_pay_id", "oneoff_campaing_pay_id", "clientSecret",
  "stripe_token_id",
]);
const transportFields = new Set(["idempotency_key"]);

const campaignRequestHeaders = (values) => ({
  ...authHeader({ contentType: "multipart/form-data" }),
  ...(values && values.idempotency_key
    ? { "Idempotency-Key": values.idempotency_key }
    : {}),
});

const positiveInteger = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

const paymentIntentId = (values = {}) => {
  if (typeof values.payment_intent_id === "string" && values.payment_intent_id) return values.payment_intent_id;
  if (typeof values.paymentIntentId === "string" && values.paymentIntentId) return values.paymentIntentId;
  if (values.paymentIntent && typeof values.paymentIntent === "object") return values.paymentIntent.id || null;
  if (values.error && typeof values.error === "object") {
    const intent = values.error.payment_intent;
    if (typeof intent === "string" && intent) return intent;
    if (intent && typeof intent === "object") return intent.id || null;
  }
  return null;
};

const create = (values) => {
  const auth = store.getState?.()?.auth || {};
  const auth_key = auth?.user?.auth_key || "";
  const formData = new FormData();
  for (let value in values) {
    if (retiredPaymentFields.has(value) || transportFields.has(value)) continue;
    formData.append(value, values[value]);
  }
  const action = "afterlogin/oneoffcampaign/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: campaignRequestHeaders(values) });
};

const update = (values) => {
  const auth = store.getState?.()?.auth || {};
  const auth_key = auth?.user?.auth_key || "";
  const clickEvent = values && values.clickEvent;
  if (clickEvent && clickEvent === "statusupdate") {
    const statusData = {
      is_active: values.is_active ? 1 : 0,
      auth_key,
      action: `afterlogin/oneoffcampaign/isactive/${values.id}`,
    };
    const statusFormData = new FormData();
    Object.entries(statusData).forEach(([key, value]) => statusFormData.append(key, value));
    return axios.post(API_URL + statusData.action, statusFormData, { headers: authHeader({ contentType: "multipart/form-data" }) });
  }
  const formData = new FormData();
  for (let value in values) {
    if (retiredPaymentFields.has(value) || transportFields.has(value)) continue;
    formData.append(value, values[value] ? values[value] : "");
  }
  const action = "afterlogin/oneoffcampaign/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: campaignRequestHeaders(values) });
};

const view = (values) => {
  const request = buildCampaignViewRequest("afterlogin/oneoffcampaign/view", values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/oneoffcampaign/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const oneoffpayment = (values) => {
  const action = `afterlogin/oneoffcampaign/oneoffpayment`;
  const intentId = paymentIntentId(values);
  const payId = positiveInteger(values && values.oneoff_campaign_pay_id);
  const payload = intentId && payId ? { payment_intent_id: intentId, oneoff_campaign_pay_id: payId } : {};
  return axios.post(API_URL + action, payload, { headers: authHeader() });
};

const oneoffpaymentfailed = (values) => {
  const action = `afterlogin/oneoffcampaign/oneoffpaymentfailed`;
  const intentId = paymentIntentId(values);
  const payId = positiveInteger(values && values.oneoff_campaign_pay_id);
  const payload = intentId && payId ? { payment_intent_id: intentId, oneoff_campaign_pay_id: payId } : {};
  return axios.post(API_URL + action, payload, { headers: authHeader() });
};

const createpaymentintent = (values = {}) => {
  const campaignId = positiveInteger(values.campaign_id || values.id || values.oneoff_campaign_id || values.oneoff_campaing_id);
  const action = "afterlogin/oneoffcampaign/createpaymentintent";
  return axios.post(API_URL + action, campaignId ? { campaign_id: campaignId } : {}, { headers: authHeader() });
};

const sendemail = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = 'afterlogin/oneoffcampaign/sendemail';
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value] ? values[value] : "");
  }
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const OneoffCampaignApiController = {
  create,
  update,
  view,
  deleted,
  createpaymentintent,
  oneoffpaymentfailed,
  oneoffpayment,
  sendemail
};
export default OneoffCampaignApiController;
